LhApp = LhApp || {};

LhApp.Function = {};

LhApp.Function.Url = {};
LhApp.Function.QueryString = {};
LhApp.Function.String = {};
LhApp.Function.Tracking = {};

//custom ga in
LhApp.Function.Tracking.ga = function () {

    if (!LhApp.Function.Tracking.canTrack('statisticCookies'))
        return;

    //pure ga tracking can be used only in conjuction with tag manager enabled
    if (!LhApp.Function.Tracking.InitGoogleAnalytics())
        return;

    ga.apply(this, arguments);
}

LhApp.Function.Tracking.canTrack = function (cookieType) {
    var Consents = (typeof (ConsentsManager) != "undefined" && ConsentsManager) || (typeof (CheckoutConsentsManager) != "undefined" && CheckoutConsentsManager);
    if (!Consents)
        return false;

    if (!cookieType)
        cookieType = 'marketingCookies';

    if (Consents.cookiesStatus[cookieType] === undefined)
        return false;

    return LhApp.Context.IsConsentsEnabled && Consents.cookiesStatus[cookieType] ? true : false;
}

LhApp.Function.Tracking.getTrackingModel = function () {
    var trackingModel = window.TrackingData;
    if (!trackingModel || !trackingModel.IsTrackingEnabled)
        return null;

    return JSON.parse(JSON.stringify(trackingModel));//retunr cloned object
}

LhApp.Function.Tracking.getTracker = function (trackerCode, trackingModel) {    
    if (!trackingModel || !trackingModel.IsTrackingEnabled)
        return null;

    var tracker = trackingModel.Trackers[trackerCode.toLowerCase()]; // if available than IsActive = 1 in DB
    if (!tracker)
        return null;

    if (!tracker.Properties)
        return null;

    return tracker;
}

LhApp.Function.Tracking.getFeedItemId = function (product, productId, colorId, feedCodeField) {
    if (!product || !productId)
        return null;

    if (product.FeedCodes && product.FeedCodes[feedCodeField])
        return product.FeedCodes[feedCodeField];

    productId = productId.toString();
    if (colorId && colorId > 0) {
        productId += "-" + colorId;
    }

    return productId;
}

LhApp.Function.Tracking.InitGoogleTagManager = function (tagManagerCode) {
    if (tagManagerCode === undefined) // if not defined
    {
        var trackingModel = LhApp.Function.Tracking.getTrackingModel();
        if (!trackingModel || !trackingModel.GoogleTagManagerCode)
            return false;
        tagManagerCode = trackingModel.GoogleTagManagerCode;
    }

    if (!tagManagerCode)
        return false;

    //initialization check
    if (window.googleTagManagerInitialized)
        return true;
    window.googleTagManagerInitialized = true;

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', tagManagerCode);

    return true;
}

LhApp.Function.Tracking.InitGoogleAnalytics = function (analyticsCode) {
    if (analyticsCode === undefined) // if not defined
    {
        var trackingModel = LhApp.Function.Tracking.getTrackingModel();
        if (!trackingModel || !trackingModel.GoogleAnalyticsCode)
            return false;
        analyticsCode = trackingModel.GoogleAnalyticsCode;
    }

    if (!analyticsCode)
        return false;

    //initialization check
    if (window.googleAnalyticsInitialized)
        return true;
    window.googleAnalyticsInitialized = true;

    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga("create", analyticsCode, 'auto');

    return true;
}

LhApp.Function.Url.getServiceEndpoint = function (url) {
    var rewritedUrl = LhApp.Context.Request.BaseUrl + '/services/';

    rewritedUrl += url;

    if (unescape(LhApp.Context.Request.FriendlyUrl).indexOf('?') != -1) {

        var queryString = '';
        var initialQueryString = unescape(LhApp.Context.Request.FriendlyUrl).substring(unescape(LhApp.Context.Request.FriendlyUrl).indexOf('?') + 1);

        var iid = LhApp.Function.QueryString.getValueOf('iid', unescape(LhApp.Context.Request.RawUrl));
        if (iid != '') queryString = 'iid=' + iid;
        else if (LhApp.Context.Item && LhApp.Context.Item.Id)
            queryString = 'iid=' + LhApp.Context.Item.Id;
        if (rewritedUrl.indexOf(initialQueryString) == -1) {

            if (initialQueryString.length > 0) queryString += '&' + initialQueryString;

            if (rewritedUrl.indexOf('?') == -1)
                queryString = '?' + queryString;
            else
                queryString = '&' + queryString;
        }
        rewritedUrl += queryString;
    }

    rewritedUrl = rewritedUrl.replace("?&", "?");
    var domainUrl = rewritedUrl.split('?');
    var qsrt = "";
    if (domainUrl.length > 1) {
    	var q = domainUrl[1];
    	var qArray = q.split('&');
    	var operator = '?';
    	for (i = 0; i < qArray.length; i++) {
    		if (qArray[i] != "" && qArray[i] != "" && qsrt.indexOf(qArray[i]) == -1) {
    			if (i == 0) {
    				operator = '?';
    			} else {
    				operator = '&';
    			}
    			qsrt += operator + qArray[i];
    		}
    	}
    }
    return domainUrl[0] + qsrt;
};

LhApp.Function.QueryString.getValueOf = function (parameterKey, url) {

    url = url || window.location.href;
    var parameterValue = '';

    var queryString = '';
    var hasQueryString = (url.indexOf('?') > -1);

    if (hasQueryString) {
        queryString = url.substring(url.indexOf('?') + 1);
    }

    var parameters = queryString.split("&");

    if (queryString.indexOf(parameterKey) >= 0) {

        for (var i = 0; i < parameters.length; i++) {
            var pair = parameters[i].split("=");
            if (pair[0] == parameterKey) {
                parameterValue = pair[1];
            }
        }
    }

    return parameterValue;
};

LhApp.Function.Url.setParameterValue = function (parameterKey, parameterValue) {

    var url = window.location.href;

    return this.setParameterValueOnUrl(url, parameterKey, parameterValue);
};

LhApp.Function.Url.setParameterValueOnUrl = function (url, parameterKey, parameterValue) {

    var newUrl;

    var queryString = '';
    var hasQueryString = (url.indexOf('?') > -1);

    if (hasQueryString) {
        queryString = url.substring(url.indexOf('?') + 1);
    }

    var parameters = queryString.split("&");

    if (queryString.indexOf(parameterKey) >= 0) {

        for (var i = 0; i < parameters.length; i++) {
            var pair = parameters[i].split("=");
            if (pair[0] == parameterKey) {
                parameters[i] = pair[0] + "=" + parameterValue;
            }
        }

        queryString = parameters.join("&");

    } else {
        if (hasQueryString) {
            queryString += '&' + parameterKey + '=' + parameterValue;
        } else {
            queryString += '?' + parameterKey + '=' + parameterValue;
        }
    }

    if (hasQueryString) {
        newUrl = url.substring(0, url.indexOf('?') + 1) + queryString;
    } else {
        newUrl = url + queryString;
    }

    return newUrl;
};

LhApp.Function.Url.removeParameter = function (parameterKey) {

    var url = window.location.href;
    var parameterKeys = [parameterKey];

    return this.removeParametersFromUrl(url, parameterKeys);
};

LhApp.Function.Url.removeParameterFromUrl = function (url, parameterKey) {
    var parameterKeys = [parameterKey];

    return this.removeParametersFromUrl(url, parameterKeys);
};

LhApp.Function.Url.removeParameters = function (parameterKeys) {

    var url = window.location.href;

    return this.removeParametersFromUrl(url, parameterKeys);
};

LhApp.Function.Url.removeParametersFromUrl = function (url, parameterKeys) {

    var newUrl = url;

    $.each(parameterKeys, function (index, parameterKey) {

        var queryString = '';
        var hasQueryString = (newUrl.indexOf('?') > -1);

        if (hasQueryString) {
            queryString = newUrl.substring(newUrl.indexOf('?') + 1);

            var parameters = queryString.split("&");

            if (queryString.indexOf(parameterKey) >= 0) {

                for (var i = 0; i < parameters.length; i++) {
                    var pair = parameters[i].split("=");
                    if (pair[0] == parameterKey) {
                        parameters.splice(i, 1);
                    }
                }

                queryString = parameters.join("&");
                if (queryString != "")
                    newUrl = newUrl.substring(0, newUrl.indexOf('?') + 1) + queryString;
                else
                    newUrl = newUrl.substring(0, newUrl.indexOf('?')) + queryString;
            }
        }
    });

    return newUrl;
};

LhApp.Function.getText = function (key) {

    if (typeof LhApp.Text == 'undefined')
        return '';

    var match = LhApp.Text[key];
    if (match === undefined) {
        var resource = LhApp.Function.getTranslatableTextFromServer(key);
        LhApp.Text[key] = resource;
        match = resource;
    }

    return match || '';
};

LhApp.Function.getTranslatableTextFromServer = function (key) {
    var result = key;
    $.ajax({
        async: false,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=UTF-8',
        ContentType: 'application/json; charset=UTF-8',
        url: LhApp.Function.Url.getServiceEndpoint('commonservice.svc/GetTranslatableResource'),
        data: JSON.stringify({
            key: key
        }),
        success: function (response) {
            result = response.d;
        }
    });

    return result;
};

LhApp.Function.String.isEmail = function(text) {
    //var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i;
    var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-||_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+([a-z]+|\d|-|\.{0,1}|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])?([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
    return re.test(text);
};

LhApp.Function.String.isAlphaNumeric = function (text) {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    return text.match(letterNumber) || false;
};

LhApp.Function.initVisitorState = function () {

    var cookieValue = Cookies.get("VisitorState");
    if (cookieValue) {

        LhApp.Function.checkAndUpdateVisitorState(cookieValue);

    } else {

        Vendd.Service.call({
            url: 'CmsService.svc/InitVisitorState',
            data: null,
            onSuccess: function (res) {

                cookieValue = Cookies.get("VisitorState");
                if (res.success && cookieValue) {
                    LhApp.Function.checkAndUpdateVisitorState(cookieValue);
                }
            }
        });
    }
};

LhApp.Function.checkAndUpdateVisitorState = function (cookieValue) {

    if (cookieValue) {

        var oldUrl = window.location.href;
        var cookieValueAsUrl = "?" + cookieValue;

        $('body').removeClass('x-checking-visitor-state').removeAttr('x-checking-visitor-state');

        // 1. Checks to update cookie values from querystring
        var oldLanguageCode = LhApp.Function.QueryString.getValueOf("languageCode", cookieValueAsUrl).toLowerCase();
        var newLanguageCode = LhApp.Function.QueryString.getValueOf("lang", oldUrl).toLowerCase();

        if (newLanguageCode != '' && newLanguageCode != oldLanguageCode) {
            cookieValue = LhApp.Function.Url.setParameterValueOnUrl(cookieValueAsUrl, "languageCode", newLanguageCode).replace("?", "");
            Cookies.set("VisitorState", cookieValue, { secure: LhApp.Context.Request.IsSecure, samesite: 'Lax' });
            cookieValueAsUrl = "?" + cookieValue;
        }

        var oldCountryCode = LhApp.Function.QueryString.getValueOf("countryCode", cookieValueAsUrl).toLowerCase();
        var newCountryCode = LhApp.Function.QueryString.getValueOf("country", oldUrl).toLowerCase();

        if (newCountryCode != '' && newCountryCode != oldCountryCode) {
            cookieValue = LhApp.Function.Url.setParameterValueOnUrl(cookieValueAsUrl, "countryCode", newCountryCode).replace("?", "");
            Cookies.set("VisitorState", cookieValue, { secure: LhApp.Context.Request.IsSecure, samesite: 'Lax' });
            cookieValueAsUrl = "?" + cookieValue;
        }

        var oldCurrencyCode = LhApp.Function.QueryString.getValueOf("currencyCode", cookieValueAsUrl).toLowerCase();
        var newCurrencyCode = LhApp.Function.QueryString.getValueOf("currency", oldUrl).toLowerCase();

        if (newCurrencyCode != '' && newCurrencyCode != oldCurrencyCode) {
            cookieValue = LhApp.Function.Url.setParameterValueOnUrl(cookieValueAsUrl, "currencyCode", newCurrencyCode).replace("?", "");
            Cookies.set("VisitorState", cookieValue, { secure: LhApp.Context.Request.IsSecure, samesite: 'Lax' });
            cookieValueAsUrl = "?" + cookieValue;
        }
    }
};

LhApp.Function.hideExpandables = function (wrapper) {
    var $expandables = $('*[data-expandablecontainer].x-expanded:not(.x-loading)', $(wrapper));
    $expandables.each(function (i, item) {
        var $expandable = $(item);
        $expandable.removeClass('x-expanded');
        $('*[data-expandabletrigger="' + $expandable.data('expandablecontainer') + '"].x-open', $(wrapper)).removeClass('x-open');
    });
};

LhApp.Function.bindUndropables = function (wrapper) {
    var $wrapper = $(wrapper);

    var $undropableElements = $('*[data-undropable]', $wrapper);
    $undropableElements.on('drop', function (e) {
        if (typeof (e.preventDefault) === 'function')
            e.preventDefault();
    });
};

LhApp.Function.bindExpandables = function (wrapper) {
    var $wrapper = $(wrapper);

    var $expandableContainers = $('*[data-expandablecontainer]', $wrapper);
    $expandableContainers.click(function (e) {
        e.stopPropagation();
    });

    var $triggers = $('*[data-expandabletrigger]', $wrapper);
    $triggers.each(function (i, item) {
        var $trigger = $(item);

        var triggerValue = $trigger.data('expandabletrigger');
        var $expandableContainer = $('*[data-expandablecontainer="' + triggerValue + '"]', $wrapper);

        var $triggers = $('*[data-expandabletrigger="' + triggerValue + '"]', $wrapper);

        if ($expandableContainer.length > 0) {
            $triggers.unbind('click');
            $triggers.click(function (e) {
                e.preventDefault();
                e.stopPropagation();

                $('*[data-expandablecontainer].x-expanded').each(function (w, wItem) {
                    var wItemContainer = $(wItem).data('expandablecontainer');
                    if (wItemContainer != triggerValue) {
                        $(wItem).removeClass('x-expanded');
                        $('*[data-expandabletrigger="' + wItemContainer + '"].x-open').removeClass('x-open');
                    }
                });

                if ($expandableContainer.hasClass('x-expanded')) {
                    $expandableContainer.removeClass('x-expanded');
                    $triggers.removeClass('x-open');
                } else {
                    $expandableContainer.addClass('x-expanded');
                    $triggers.addClass('x-open');

                    EventManager.trigger('lazyload');
                }
            });
        }
    });
};

LhApp.Function.isButtonDisabled = function (buttonWrapper) {
    var isDisabled = false;

    if ($(buttonWrapper).get(0).tagName.toLowerCase() == 'input') {
        if ($(buttonWrapper).is(':disabled'))
            isDisabled = true;
    }
    else {
        var $internalButton = $(buttonWrapper).find('input:button');
        if ($internalButton.length > 0) {
            if ($internalButton.is(':disabled'))
                isDisabled = true;
        }
        else if ($(buttonWrapper).hasClass('x-disabled')) {
            isDisabled = true;
        }
    }

    return isDisabled;
};

LhApp.Function.bindHrefButtons = function (wrapper) {
    $('*[data-href]', $(wrapper)).click(function (e) {
        if (e !== undefined && typeof (e.preventDefault) == 'function')
            e.preventDefault();

        var isDisabled = LhApp.Function.isButtonDisabled(this);
        if (isDisabled) {
            e.preventDefault();
        }
        else {
            document.location = $(this).data('href');
        }
    });
};

LhApp.Function.bindScrollable = function (wrapper) {
    $('*[data-scroll-to]', $(wrapper)).click(function () {
        var $this = $(this),
            element = $this.data('scroll-to'), time = $this.data('scroll-time'), offset = $this.data('scroll-offset'),
            time = (typeof time == "undefined" || time == "") ? 600 : time,
            offset = (typeof offset == "undefined" || offset == "") ? -10 : offset;

        if (element == "")
            return;

        if (element == "top") {
            $('html, body').animate({
                scrollTop: 0
            }, time);
        }
        if (element == "bottom") {
            $('html, body').animate({
                scrollTop: $('body').height()
            }, time);
        }
        if ($(element).length > 0) {
            $('html, body').animate({
                scrollTop: $(element).offset().top + offset
            }, time);
        }
    });
};

LhApp.Function.bindLazyLoadableImages = function (wrapper) {

    var $selectedWrapper;
    if ($(wrapper).data('lazy-load-init')) {
        $selectedWrapper = $(wrapper);
    } else {
        $selectedWrapper = $('*[data-lazy-load-init]', $(wrapper));
    }

    $selectedWrapper.each(function (i, innerWrapper) {

        var $innerWrapper = $(innerWrapper);
        var $lazyLoadOptions = $('*[data-input="lazy-load-options"]', $innerWrapper);
        var initLazyLoad = $innerWrapper.data('lazy-load-init');

        if (initLazyLoad) {

            var opts = {};
            var defOptions = {
                effect: "fadeIn"
            };

            if ($lazyLoadOptions.length == 1) {
                $.extend(true, opts, defOptions, JSON.parse($lazyLoadOptions.val()));
            } else {
                $.extend(true, opts, defOptions);
            }

            var $images = $("img[data-lazyload]", $innerWrapper);
            if ($images.length > 0 && typeof $.fn.lazyload === "function") {
                $($images, $innerWrapper).lazyload(opts);
            }

        }

        if ($lazyLoadOptions.length > 0) {
            $lazyLoadOptions.remove();
        }

    });

    if ($.inArray('lazyload', EventManager.events) == -1) {
        EventManager.bind('lazyload', function () {
            $(window).trigger('lazyload');
        });
    }

};

LhApp.Function.PageTrackingRequest = function () {
    var url = decodeURIComponent(LhApp.Context.Request.RawUrl);
    var qstr = url.substring(url.indexOf('?') + 1);
    var dataItem = {
        querystring: qstr,
        cookie: document.cookie
    };

    Vendd.Service.call({
        url: 'MarkService.svc/PageTracking',
        data: { query: dataItem },
        onSuccess: function (res) {

            var cookies = res;
            for (var i = 0; i < cookies.length; i++) {
                document.cookie = cookies[i].Name + "=" + cookies[i].Value + "; expires=" + (new Date(cookies[i].Expires)).toUTCString() + "; path=" + cookies[i].Path;
            }
        }
    });
};

LhApp.Function.MailChimpEcommerce360Tracking = function (oId, cId, eId) {

    Vendd.Service.call({
        url: 'MarkService.svc/MailChimpEcommerce360Tracking',
        data: { orderId: oId, campaignId: cId, emailId: eId }
    });
};

LhApp.Function.applyExchangeRate = function (price) {
    return LhApp.Function.applyExchangeRateExtended(price, LhApp.Context.Currency.ExchangeRate);
};

LhApp.Function.applyExchangeRateExtended = function (price, rate) {
    return price * rate;
};

LhApp.Function.handleItemStatistics = function () {

    var itemStatisticsDataArray = [];

    $('.x-control[data-manipulate-stats="true"]').each(function (i, control) {

        var $control = $(control);
        var itemId = $control.data('stats-itemid');
        var action = $control.data('stats-action');
        var data = { ItemId: itemId, Action: action };

        if ($.inArray(data, itemStatisticsDataArray) == -1)
            itemStatisticsDataArray.push(data);
    });

    if (itemStatisticsDataArray.length > 0) {

        Vendd.Service.call({
            url: 'StatsService.svc/ManipulateItemStatistics',
            data: { data: itemStatisticsDataArray }
        });
    }
};

// multiple wishlists
LhApp.Function.showProductWishlists = function($wrapper, product) {
    if (!LhApp.Context.MultipleWishlistsEnabled || $wrapper.length == 0)
        return;

    $wrapper.addClass('x-loading');

    var $wishlistsWrapper = $('.js-wishlist-lists', $wrapper);

    var model = Vendd.UserWishlist.GetClientModel();
    model = $.extend({}, model, { Product: product });

    var html = Vendd.Handlebars.parse("productWishlists", model);
    $wishlistsWrapper.html(html);
    LhApp.Function.bindProductWishlists($wrapper);
    $wishlistsWrapper.show();

    $wrapper.removeClass('x-loading');
};

LhApp.Function.bindProductWishlists = function ($wrapper) {
    if (!LhApp.Context.MultipleWishlistsEnabled)
        return;

    var $lists = $('.js-list-select', $wrapper);
    $lists.on('click', function() {
        var $this = $(this);

        var $wishlistsWrapper = $this.closest('.js-product-wishlists');
        var $wrper = $this.closest('.product-wishlist');

        var qs = LhApp.Function.QueryString.getValueOf('list');

        var id = $wishlistsWrapper.data('id'),
            skuId = $wishlistsWrapper.data('skuid'),
            path = $wishlistsWrapper.data('path'),
            qty = $wishlistsWrapper.data('qty'),
            extraAttributes = [],
            bundleItems = [],
            listId = $wrper.data('list-id'),
            currentListId = qs ? parseInt(qs) || 0 : 0;

        Vendd.MessageBus.publishAsync($wrapper.get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, listId, currentListId));
        Vendd.MessageBus.publishAsync($wrapper.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistWidget, false));
        LhApp.Function.hideAllProductWishlists();
    });

    $wrapper.on('click', '.js-close-product-wishlists', function (e) {
		e.preventDefault();
		LhApp.Function.hideAllProductWishlists();
	});
};

LhApp.Function.hideAllProductWishlists = function () {
    if (!LhApp.Context.MultipleWishlistsEnabled)
        return;

    $.each($('.js-wishlist-lists'), function (i, el) {
        $(el).html("");
        $(el).hide();
    });
};
// multiple wishlists

var RenderPrice = function (price) {
    return LhApp.Function.renderPriceExtended(price, false, ' ', '', '');
};

var RenderPriceExtended = function (price, isShopDefaultCurrency, separatorSymbol, prefixSymbol, suffixSymbol) {
    return LhApp.Function.renderPriceExtended(price, isShopDefaultCurrency, separatorSymbol, prefixSymbol, suffixSymbol);
};

LhApp.Function.renderPrice = function (price) {
    return LhApp.Function.renderPriceExtended(price, false, ' ', '', '');
};

LhApp.Function.renderPriceExtended = function (price, isShopDefaultCurrency, separatorSymbol, prefixSymbol, suffixSymbol) {

    var symbol = LhApp.Context.Currency.Symbol;
    var numberOfDigits = LhApp.Context.Currency.NumberOfDigits;
    var symbolShownFirst = LhApp.Context.Currency.SymbolShownFirst;
    var doShowSymbol = LhApp.Context.Currency.DoShowSymbol;

    if (isShopDefaultCurrency) {
        symbol = LhApp.Context.ShopDefaultCurrency.Symbol;
        numberOfDigits = LhApp.Context.ShopDefaultCurrency.NumberOfDigits;
        symbolShownFirst = LhApp.Context.ShopDefaultCurrency.SymbolShownFirst;
        doShowSymbol = LhApp.Context.ShopDefaultCurrency.DoShowSymbol;
    }

    var formatedPrice = price.toFixed(numberOfDigits).replace('.', ',');

    if (doShowSymbol) {
        if (!symbolShownFirst) {
            formatedPrice = formatedPrice + separatorSymbol + symbol;
        } else {
            formatedPrice = symbol + separatorSymbol + formatedPrice;
        }
    }

    if (prefixSymbol != '') {
        formatedPrice = prefixSymbol + separatorSymbol + formatedPrice;
    }

    if (suffixSymbol != '') {
        formatedPrice = formatedPrice + separatorSymbol + suffixSymbol;
    }

    return formatedPrice;
};

var RenderPointsPrice = function (pointsPrice) {
    return LhApp.Function.renderPointsPriceExtended(pointsPrice, ',', ' ', '', '');
};

var RenderPointsPriceExtended = function (pointsPrice, commaSymbol, separatorSymbol, prefixSymbol, suffixSymbol) {
    return LhApp.Function.renderPointsPriceExtended(pointsPrice, commaSymbol, prefixSymbol, suffixSymbol);
};

LhApp.Function.renderPointsPriceExtended = function (pointsPrice, commaSymbol, separatorSymbol, prefixSymbol, suffixSymbol) {

    if (suffixSymbol == '') {
        suffixSymbol = pointsPrice === 1 ? 'point' : 'points';
    }

    var innerSuffixSymbol = suffixSymbol.length > 1 ? ' ' + LhApp.Function.getText('Common:PointsPriceSymbol_' + suffixSymbol) : suffixSymbol;

    var formatedPrice = pointsPrice.toFixed(2).replace('.00', '').replace('.', commaSymbol);

    if (prefixSymbol != '') {
        formatedPrice = prefixSymbol + separatorSymbol + formatedPrice;
    }

    if (innerSuffixSymbol != '') {
        formatedPrice = formatedPrice + separatorSymbol + innerSuffixSymbol;
    }

    return formatedPrice;
};

LhApp.Function.validateClientModel = function(model) {
    if (!model) return false;

    if (!model.LangCode || model.LangCode != LhApp.Context.Language) return false;

    return true;
}

var ReplacePrices = function (obj) {
    $('.x-product-box[data-productid]').each(function (i, el) {
        var itemId = parseInt($(el).attr('data-productid'));

        var itemData = obj.filter(function (a) { return a.Id === itemId })[0]

        var DeletedPrice = parseFloat(itemData.DeletedPrice);
        var Price = parseFloat(itemData.Price);
        var TotalPointsPrice = parseFloat(itemData.TotalPointsPrice);
        var TotalPointsGain = parseFloat(itemData.TotalPointsGain);
        var PointsPrice = parseFloat(itemData.PointsPrice);
        var PointsGain = parseFloat(itemData.PointsGain);

        // hide all
        $('.prices', el).addClass('hide');
        $('.deleted-price-container', el).addClass('hide');
        $('.current-price-container', el).addClass('hide');
        $('.current-point-price-container.1', el).addClass('hide');
        $('.current-point-price-container.2', el).addClass('hide');
        $('.current-point-price-container.3', el).addClass('hide');
        $('.current-point-price-container.4', el).addClass('hide');

        if (DeletedPrice > 0 || Price > 0 || TotalPointsPrice > 0 || TotalPointsGain > 0 || PointsPrice > 0 || PointsGain > 0) {
            $('.prices', el).removeClass('hide');

            if ((DeletedPrice > 0) && (DeletedPrice > Price)) {
                $('.deleted-price-container', el).removeClass('hide');
                $('.deleted-price', el).text(RenderPrice(itemData.DeletedPrice));
            }

            if (Price > 0) {
                $('.current-price-container', el).removeClass('hide');
                $('.current-price', el).text(RenderPrice(itemData.Price));
            }

            if (PointsPrice > 0 && PointsPrice != TotalPointsPrice) {
                $('.current-point-price-container.1', el).removeClass('hide');
                $('.current-point-price-container.1 .points-price', el).text(RenderPointsPrice(PointsPrice));
            }

            if (TotalPointsGain > 0) {
                $('.current-point-price-container.2', el).removeClass('hide');
                $('.current-point-price-container.2 .points-gain', el).text(RenderPointsPrice(TotalPointsGain));
            }

            if (PointsGain > 0 && TotalPointsGain === 0) {
                $('.current-point-price-container.3', el).removeClass('hide');
                $('.current-point-price-container.3 .points-gain', el).text(RenderPointsPrice(PointsGain));
            }

            if (TotalPointsPrice > 0) {
                $('.current-point-price-container.4', el).removeClass('hide');
                $('.current-point-price-container.4 .points-price', el).text(RenderPointsPrice(TotalPointsPrice));
            }
        }
    });
}

var ReplaceAvailabilities = function (obj) {
    $('.x-product-box[data-productid]').each(function (i, el) {
        var itemId = parseInt($(el).attr('data-productid'));
        var itemData = obj.filter(function (a) { return a.Id === itemId })[0]

        var cartEnabled = itemData.CanBuy === true || itemData.CanBuyWithPoints === true;
        var wishlistEnabled = itemData.CanAddToList === true;

        if ($('.buttons .add-to-cart').length > 0 && $('.buttons .add-to-cart input').length > 0) {
            $('.buttons .add-to-cart').addClass('x-disabled');
            $('.buttons .add-to-cart input').attr('disabled', 'disabled');

            if (cartEnabled === true) {
                $('.buttons .add-to-cart').removeClass('x-disabled');
                $('.buttons .add-to-cart input').removeAttr('disabled', 'disabled');
            }
        }

        //if ($('.buttons .add-to-wishlist').length > 0 && $('.buttons .add-to-wishlist input').length > 0) {
        //$('.buttons .add-to-wishlist').addClass('x-disabled');
        //$('.buttons .add-to-wishlist input').attr('disabled', 'disabled');

        //if (wishlistEnabled === true) {
        //$('.buttons .add-to-wishlist').removeClass('x-disabled');
        //$('.buttons .add-to-wishlist input').removeAttr('disabled', 'disabled');
        //}
        //}
    });
}

LhApp.Function.validateTaxIdentifier = function (isInvoice, countryCode, taxIdentifier) {
    if (isInvoice === true && taxIdentifier.length > 0) {
        if (countryCode === 'GR') {
            if (!isNaN(parseInt(taxIdentifier)) && taxIdentifier.length === 9) {
                var result = 0;
                var arrTaxId = taxIdentifier.split("").map(function (item) {
                    return parseInt(item);
                });

                for (var i = arrTaxId.length - 2; i >= 0 ; i--) {
                    result = result + arrTaxId[i] * Math.pow(2, (8 - i));
                }

                if ((result % 11) % 10 === arrTaxId[8]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        else
            return true;
    }

    return false;
};

LhApp.pauseScroll = false;

LhApp.init = function () {

    LhApp.Function.bindScrollable($('body').get(0));
    LhApp.Function.bindExpandables($('body').get(0));
    LhApp.Function.bindHrefButtons($('body').get(0));
    LhApp.Function.bindUndropables($('body').get(0));
    //LhApp.Function.bindLazyLoadableImages($('body').get(0));

    if (LhApp.Context.IsConsentsEnabled) {
        if (window.ScriptsActivator.consentStatus.marketingCookies) {
            LhApp.Function.PageTrackingRequest();
        }
    } else {
        LhApp.Function.PageTrackingRequest();
    }

    LhApp.Function.handleItemStatistics();

    $('body').click(function (e) {
        LhApp.Function.hideExpandables(this);
    });

    $(document).scroll(function (e) {
        if (!LhApp.pauseScroll)
            LhApp.Function.hideExpandables($('body').get(0));
    });
};

var disqus_config = function () {

    if (LhApp.Context.Item.Id && LhApp.Context.Request.FriendlyUrl) {

        this.page.url = LhApp.Context.Request.BaseUrl + LhApp.Context.Request.FriendlyUrl;
        this.page.identifier = LhApp.Context.Item.Id;

    }
};

var replaceIframe = function (idFrame, url) {
    var originalFrame = document.getElementById(idFrame);
    var newFrame = document.createElement("iframe");
    newFrame.id = originalFrame.getAttribute("id");
    newFrame.width = originalFrame.getAttribute("width");
    newFrame.height = originalFrame.getAttribute("height");
    newFrame.style.display = "none";
    newFrame.src = url;
    var parent = originalFrame.parentNode;
    parent.replaceChild(newFrame, originalFrame);
}

var convertToGreek = function() {
    $("input[type='text'].js-convert-to-greek").keyup(function () {
        if ($(this).closest('.form-row').find('.js-disable-conversion').is(':checked')) return;
        var str = $(this).val().toUpperCase();
        var newstr = [];
        for (var i = 0, len = str.length; i < len; i++) {
            newstr[i] = convertCharacters(str[i]);
        }
        $(this).val(newstr.join(""));
        $(this).trigger("input"); //just to let angular know
    });
}

var convertCharacters = function(character) {
    switch (character) {
        case "A":
            character = 'Α';
            break;
        case "B":
            character = 'Β';
            break;
        case "C":
            character = 'Ψ';
            break;
        case "D":
            character = 'Δ';
            break;
        case "E":
            character = 'Ε';
            break;
        case "F":
            character = 'Φ';
            break;
        case "G":
            character = 'Γ';
            break;
        case "H":
            character = 'Η';
            break;
        case "I":
            character = 'Ι';
            break;
        case "J":
            character = 'Ξ';
            break;
        case "K":
            character = 'Κ';
            break;
        case "L":
            character = 'Λ';
            break;
        case "M":
            character = 'Μ';
            break;
        case "N":
            character = 'Ν';
            break;
        case "O":
            character = 'Ο';
            break;
        case "P":
            character = 'Π';
            break;
        case "Q":
            character = 'Κ';
            break;
        case "R":
            character = 'Ρ';
            break;
        case "S":
            character = 'Σ';
            break;
        case "T":
            character = 'Τ';
            break;
        case "U":
            character = 'Θ';
            break;
        case "V":
            character = 'Ω';
            break;
        case "W":
            character = 'Σ';
            break;
        case "X":
            character = 'Χ';
            break;
        case "Y":
            character = 'Υ';
            break;
        case "Z":
            character = 'Ζ';
            break;
    }
    return character;
}